<template lang="pug">


  .tutor-trans
    img(style="display:none" ref="liqtrans" src="~assets/ui/liq2trans.png")
    canvas.mode-trans(ref="trans")


</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as MODES from 'src/config/modes'
import Raf from 'src/helpers/Raf'

export default {
  name: 'tutor-trans',
  components: {
  },
  data() {
    return {
      timeline: 0,
      timeline2: 1,
      timeline3: 0,
      cx: 0,
      switchMode: false,
      MODES,
      modeTo: '',
      offset: 0.001,
      frame: 0,

      liqtransP: [
        {w:450, h:800, x: 1, y:1},
        {w:450, h:800, x: 1357, y:1605},
        {w:450, h:800, x: 2261, y:1},
        {w:450, h:800, x: 2713, y:1},
        {w:450, h:800, x: 3165, y:1},
        {w:450, h:800, x: 2261, y:803},
        {w:450, h:800, x: 2261, y:1605},
        {w:450, h:800, x: 2713, y:803},
        {w:450, h:800, x: 2713, y:1605},
        {w:450, h:800, x: 1, y:803},
        {w:450, h:800, x: 1, y:1605},
        {w:450, h:800, x: 453, y:1},
        {w:450, h:800, x: 453, y:803},
        {w:450, h:800, x: 453, y:1605},
        {w:450, h:800, x: 905, y:1},
        {w:450, h:800, x: 905, y:803},
        {w:450, h:800, x: 905, y:1605},
        {w:450, h:800, x: 1357, y:1},
        {w:450, h:800, x: 1357, y:803},
        {w:450, h:800, x: 1809, y:1},
        {w:450, h:800, x: 1809, y:803},
        {w:450, h:800, x: 1809, y:1605},
      ],
      left: true,
      grad:[
        {
          deg: 21.07,
          c1: '#2752A3',
          c2: '#5E80D4',
          s1: 0.1422,
          s2: 0.8905
        },
        {
          deg: 14.12,
          c1: '#B72D05',
          c2: '#CF3503',
          s1: 0.3218,
          s2: 0.8069
        },
        {
          deg: 171.36,
          c1: '#FD9F02',
          c2: '#E68203',
          s1: 0.6987,
          s2: 1
        },
        {
          deg: 14.12,
          c1: '#B72D05',
          c2: '#CF3503',
          s1: 0.3218,
          s2: 0.8069
        }
      ],
      liqColor: [
        'rgba(0, 39, 182, 0.6)',
        'rgba(179, 0, 0, 0.8)',
        'rgba(240, 124, 0, 0.8)',
        'rgba(179, 0, 0, 0.8)',
      ]
    }
  },
  props: {
    idx: {
      required: true
    }
  },
  computed: {
    ...mapState('app', ['mode', 'currSceneIdx', 'tutorProgress']),

  },
  beforeMount(){
    if (this.mode){
      this.modeTo = '大人'
    } else {
      this.modeTo = '小孩'
    }
  },
  mounted() {
    // let w = window.innerWidth
    // let h = window.innerHeight
    // let ph = h*2
    // let pw = ph*1107/867
    // this.$refs.pattern.style.width = pw+'px'
    // this.$refs.pattern.style.height = ph+'px'
    //
    // let pww = pw/3
    // //let offset = this.idx*w % pww
    // //this.$refs.pattern.style.left = `-${offset}px`
    //
    // this.cx = w/pw*1107/2
    //
    // this.patternAni()
    // this.modeSwitchAni()

    this.init()


  },
  beforeDestroy() {},

  methods: {
    ...mapMutations('app', ['toggleMode']),
    h(){
      return window.innerHeight*window.devicePixelRatio
    },
    w(){
      return window.innerWidth*window.devicePixelRatio
    },
    init(){


      console.log(888, window.innerWidth, window.innerHeight, window.devicePixelRatio)


      //this.patternCanvas = document.createElement('canvas')
      let ph = this.h() * 289/869*2
      let pw = ph * 369/289
      //this.patternCanvas.height = ph
      //this.patternCanvas.width = pw
      //this.patternCtx = this.patternCanvas.getContext('2d')
      //let patternSrc = this.$refs.pattern

      this.liqtrans = this.$refs.liqtrans
      //this.transDots = this.$refs.transDots




      this.canvas = this.$refs.trans
      this.canvas.width = this.w()
      this.canvas.height = this.h()
      this.ctx = this.canvas.getContext('2d')

      this.initGradient()


    },
    animeLeft(){
      if (!this.left){
        this.ctx.translate(this.w(), 0)
        this.ctx.scale(-1, 1)
        this.left = true
      }

      this.trans()
      //Raf.add(this.update)
    },
    animeRight(){
      if (this.left){
        this.ctx.translate(this.w(), 0)
        this.ctx.scale(-1, 1)
        this.left = false
      }
      this.trans()
      //Raf.add(this.update)
    },
    update(){

      this.ctx.clearRect(0, 0, this.w(), this.h())
      let p = this.liqtransP[Math.floor(this.frame)]
      this.ctx.globalCompositeOperation="destination-atop"
      this.ctx.drawImage(this.liqtrans, p.x, p.y, p.w, p.h, 0, 0, this.w(), this.h())
      this.ctx.globalCompositeOperation = 'source-in'
      this.ctx.fillStyle = this.grad[this.idx].grad
      //this.ctx.fillStyle = 'rgba(0, 39, 182, 0.3)'
      this.ctx.fillRect(0, 0, this.w(), this.h())
      let pp = this.tutorProgress%0.333333/0.333333
      if (this.left)
        pp = 1-pp
      this.ctx.clearRect(0, 0, this.w()*pp, this.h())
      //console.log(this.tutorProgress, pp)
    },
    initGradient(){
      let w = this.canvas.width
      let h = this.canvas.height
      for (let i=0;i<4;i++){
        let cssAng = this.grad[i].deg/180*Math.PI
        var dir = this.getDir(cssAng, w, h)
        var gr = this.ctx.createLinearGradient(dir.x0,dir.y0,dir.x1,dir.y1)
        gr.addColorStop(this.grad[i].s1, this.grad[i].c1)
        gr.addColorStop(this.grad[i].s2, this.grad[i].c2)
        this.grad[i].grad = gr
      }

    },
    getDir(radian, width, height) {
      radian += Math.PI
      const HALF_WIDTH = width * 0.5
      const HALF_HEIGHT = height * 0.5
      const lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian))
      const HALF_LINE_LENGTH = lineLength / 2
      const x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH
      const y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH
      const x1 = width - x0
      const y1 = height - y0
      return {x0, x1, y0, y1}
    },
    trans(){
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      } else {
        Raf.add(this.update)
      }
      let tl = new TimelineMax({ onComplete: () => {
          this.$emit('cueIn')
          let tl2 = new TimelineMax({ onComplete: () => {
              this.$emit('end')
              this.tl = null
              Raf.remove(this.update)
            },
          })
          this.tl = tl2

          tl2.add('start')
            .to(
              this,
              0.5,
              {
                frame: 21,
                ease: SteppedEase.config(14)
              },
              `start+=0`
            )
        },
        //repeat: -1
      })
      this.tl = tl

      tl.add('start')
        .set(
          this,
          {
            frame: 0,
          },
          `start+=0`
        )
        .to(
          this,
          0.5,
          {
            frame: 7,
            ease: SteppedEase.config(8)
          },
          `start+=0`
        )
    }

  },
  watch: {



  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.tutor-trans
  +full()
  overflow: hidden
  pointer-events: none

  //background: $cl-orange
  .mode-trans
    +full()



  .copy
    +full()
    //opacity: 0
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    font-size: $fs-xxl
    color: $cl-lightGold
    text-align: center
    transform-origin: center
    transform: rotateZ(-6deg)
    .line
      margin: 0.08rem
    .dots
      width: 1.3rem
      margin: 0.05rem
      //background: #e15125
      position: relative
      use
        fill: $cl-gold





</style>
